<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';
import { useFps } from '@vueuse/core';

const fps = useFps();
</script>

<template>
  <MMText font="Caption S/Regular" color="secondary" class="fps-counter">{{ fps }} FPS</MMText>
</template>

<style scoped lang="stylus">
.fps-counter
  padding 4px 8px
  border-radius 4px
  background-color var(--background-primary)
  border 1px solid var(--border-subtle)
</style>
